import { theme as themeDefault } from './theme';

export type ThemeOverride = Partial<typeof themeDefault>;

export function setTheme(custom?: ThemeOverride) {
  document.getElementById('theme_variables')?.remove();

  const theme = { ...themeDefault, ...custom };
  const content = Object.keys(theme).map(
    (key) => `--${key}: ${theme[key as keyof typeof theme]}`,
  );
  const style = document.createElement('style');

  style.id = 'theme_variables';
  style.textContent = `
        :root {
            ${content.join(';')}
        }
    `;
  document.head.append(style);
}
